import Crud from './crud'
import client from '@/services/client'

export default class SiteLocationService extends Crud {
  constructor (siteId) {
    super(`/site/${siteId}/permit-ministry-health`)
  }

  filter (type, status, classNumber, options) {
    if (options === undefined) {
      options = {}
    }
    const query = {}
    query.type = type
    query.status = status
    query.class_number = classNumber
    return client.post('/api/site/permit-ministry-health/filter', query, options)
  }
}
